import ih from 'immutability-helper';
import uuid from 'uuid/v4';

import _keys from 'lodash/keys';
import _pickBy from 'lodash/pickBy';

import {
  SELECT_PROJECT,
  ROLLBACK_PROJECT,
} from 'store/services/project/actionTypes';
import {
  SELECT_TEST_SET,
  DESELECT_TEST_SET,
} from 'store/services/testSets/actionTypes';
import * as types from './actionTypes';
import initialState from './initialState';

const getResetAnnotationsForTestSetEntry = (testSetEntryId, annotations) =>
  annotations.reduce((prev, curr) => {
    let currentAnnotation = { ...curr };
    if (currentAnnotation.test_entry_id === testSetEntryId) {
      currentAnnotation = {
        ...curr,
        annotations: [],
        intents: [],
        final_features: [],
        utterance: undefined,
      };
    }
    return [...prev, currentAnnotation];
  }, []);

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.ANNOTATE_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
        show: {
          data: {},
        },
      };
    case types.ANNOTATE_SUCCESS:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            isLoaded: true,
            byUser: action.payload.byUser,
            data: {
              matched_rules_map: action.payload.annotations.matched_rules_map,
              results: action.payload.annotations.results
                .filter(({ annotations }) => !!annotations)
                .map(r => ({
                  ...r,
                  annotations: r.annotations.map(a => ({
                    ...a,
                    excluded: false,
                    random_id: uuid(),
                  })),
                })),
            },
          },
        },
      });
    case types.ANNOTATE_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.TOGGLE_ANNOTATION_VISIBILITY:
      return ih(state, {
        list: {
          data: {
            results: {
              $apply: l =>
                l.map(i => {
                  const indexes = _keys(
                    _pickBy(i.annotations, { id: action.payload.id }),
                  );

                  let ret = i;
                  while (indexes.length > 0) {
                    ret = ih(ret, {
                      annotations: {
                        [indexes.pop()]: {
                          excluded: {
                            $apply: excluded => !excluded,
                          },
                        },
                      },
                    });
                  }

                  return ret;
                }),
            },
          },
        },
      });
    case types.TOGGLE_ANNOTATIONS_VISIBILITY:
      return ih(state, {
        list: {
          data: {
            results: {
              $apply: l =>
                l.map(i =>
                  ih(i, {
                    annotations: {
                      $apply: j =>
                        j.map(y =>
                          ih(y, {
                            excluded: {
                              $set: action.payload.enableAll,
                            },
                          }),
                        ),
                    },
                  }),
                ),
            },
          },
        },
      });
    case types.SELECT_ANNOTATOR_RESULT:
      return {
        ...state,
        show: {
          data: action.payload.result,
        },
      };
    case types.DESELECT_ANNOTATOR_RESULT:
      return {
        ...state,
        show: {
          data: {},
        },
      };
    case SELECT_TEST_SET:
    case DESELECT_TEST_SET:
    case SELECT_PROJECT:
    case ROLLBACK_PROJECT:
    case types.ANNOTATE_RESET:
      return {
        ...state,
        ...initialState,
      };

    case types.ANNOTATE_CANCEL:
      return ih(state, { list: { isLoading: { $set: false } } });

    case types.RESET_ANNOTATIONS_FOR_TEST_SET_ENTRY:
      return {
        ...state,
        list: {
          ...state.list,
          data: {
            matched_rules_map: {},
            results: getResetAnnotationsForTestSetEntry(
              action.payload.testSetEntryId,
              state.list.data.results,
            ),
          },
        },
      };
    default:
      return state;
  }
};
